import { Grid, Box, Typography } from "@mui/material"
import Page from "components/Page"

const Disclaimer = () => {
  return (
    <Page id="disclaimer">
      <Grid container direction="column" alignItems="center" justifyContent="center"> 
        <Box m={5} pl={5} pr={5}></Box>
          <Typography pb={2} fontFamily="Ranade" fontSize={24}>
            Disclaimer
          </Typography>
          <Typography fontFamily="General Sans" fontSize={16} maxWidth={800}>
            I am experimenting with emerging technologies. Anything I create may break, change, or 
            disappear at any time without warning. I sincerely appreciate your interest and support. 
            However, if you choose to engage with or purchase my work, you do so entirely at your own risk. 
            I make no guarantees, promises, or commitments - there are no roadmaps.
            <Box p={1}></Box>
            You are solely responsible for how you interact with my creations. Please do not treat my artwork 
            or other projects as speculative assets. Do not purchase my work with the expectation of making money, 
            reselling it for a profit, or gaining any kind of financial return. My work is created for artistic 
            exploration, expression, and experimentation - not as an investment. If you choose to support it, do 
            so because it resonates with you.
          </Typography>
        <Box m={10} pb={5}></Box>
      </Grid>
    </Page>
  )
}

export default Disclaimer
